
import React, {Component, Fragment} from 'react';
import { withRouter } from 'react-router-dom';
import MapContainer from '../../components/MapContainer';

import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {resourceOperations} from "../../redux/resource";
import {configOperations} from "../../redux/config";



class dispatchMap extends Component {
  render() {
    this.setState(this.state)
    {
      state:
          currentDispatchID: this.props.resource.currentDispatchID
    }
    return (
       <Fragment>
        <MapContainer/>
        </Fragment>
    );
   }
}
         /*<Link
          to={
            window.location.search
              ? `dispatches/${window.location.search}`
              : 'dispatches'
          }
        >
        <Button variant="contained" >
        Back to Current Dispatch
          </Button></Link>
                       */

const mapStateToProps = state => ({
 resource:{
    currentDispatchID: state.resource.currentDispatchID
  },
  map: state.map
});

const mapDispatchToProps = function(dispatch) {
  return bindActionCreators(
    {
      ...resourceOperations,
      ...configOperations
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps,
    mapDispatchToProps
  )(dispatchMap));


// WEBPACK FOOTER //
// ./src/components/dispatchMap/index.js